<script>
export default {
  name: "ToolTra",
  data() {
    return {
      tools_all: [
        // {
        //   name: "Clash",
        //   img: require("@/assets/img/clash.png"),
        //   link: "https://clashcn.com/clashdownload"
        // },
        {
          name: "文本查询",
          img: require("@/assets/img/文本查询.png"),
          link: "/textcheck",
        },
        {
          name: "货件去地址",
          img: require("@/assets/img/FBA货件地址删除.png"),
          link: "/fbaremobesaddress",
        },
      ],
    };
  },
  methods: {
    // 判断是否外链
    isExternal(link) {
      return /^https?:\/\//i.test(link);
    },
  },
};
</script>

<template>
  <div class="content-bar">
    <component
        :is="isExternal(item.link) ? 'a' : 'router-link'"
        v-for="(item, index) in tools_all"
        :key="index"
        :href="isExternal(item.link) ? item.link : undefined"
        :to="!isExternal(item.link) ? item.link : undefined"
        :target="isExternal(item.link) ? '_blank' : undefined"
        :rel="isExternal(item.link) ? 'noopener noreferrer' : undefined"
        class="tool-card"
    >
      <span class="tool-glow" />
      <img :src="item.img" :alt="item.name" class="tool-img" />
      <span class="tool-name">{{ item.name }}</span>
    </component>

    <!-- 空状态 -->
    <div v-if="!tools_all.length" class="empty">暂无工具</div>
  </div>
</template>

<style scoped>
.content-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 30px 20px;
  box-sizing: border-box;
  /* 与整体深科技蓝一致 */
  background:
      radial-gradient(120% 60% at 50% 0%, rgba(42, 74, 184, 0.18) 0%, transparent 60%),
      #0a1230;
  border-radius: 16px;
  min-height: 200px;
}

/* ===== 工具卡片 ===== */
.tool-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 140px;
  height: 150px;
  box-sizing: border-box;
  padding: 16px;
  border-radius: 14px;
  text-decoration: none;
  overflow: hidden;
  isolation: isolate;
  user-select: none;

  /* 深色玻璃底 + 霓虹描边 */
  background: rgba(22, 38, 99, 0.45);
  border: 1px solid rgba(120, 160, 255, 0.22);
  box-shadow:
      0 8px 24px -12px rgba(0, 0, 0, 0.8),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition:
      transform 0.3s ease,
      border-color 0.3s ease,
      box-shadow 0.3s ease,
      background 0.3s ease;
}

/* 悬停:上浮 + 青蓝描边 + 外发光 */
.tool-card:hover {
  transform: translateY(-6px);
  background: rgba(22, 38, 99, 0.7);
  border-color: rgba(79, 209, 255, 0.75);
  box-shadow:
      0 16px 32px -12px rgba(0, 0, 0, 0.9),
      0 0 20px rgba(79, 141, 255, 0.45),
      inset 0 0 12px rgba(79, 141, 255, 0.15);
}

/* 悬停时内部一道扫描光带 */
.tool-glow {
  position: absolute;
  inset: 0;
  background: linear-gradient(
      120deg,
      transparent 30%,
      rgba(120, 190, 255, 0.18) 50%,
      transparent 70%
  );
  transform: translateX(-120%);
  pointer-events: none;
  z-index: 1;
}
.tool-card:hover .tool-glow {
  animation: sweep 0.9s ease-out;
}
@keyframes sweep {
  0%   { transform: translateX(-120%); }
  100% { transform: translateX(120%); }
}

/* ===== 图标 ===== */
.tool-img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  position: relative;
  z-index: 2;
  /* 把深蓝线条提亮成浅蓝白 */
  filter: brightness(0) saturate(100%) invert(85%) sepia(20%) saturate(1200%) hue-rotate(190deg) brightness(105%) contrast(105%);
  transition: transform 0.3s ease, filter 0.3s ease;
}
.tool-card:hover .tool-img {
  transform: scale(1.1) rotate(-4deg);
  filter: brightness(0) saturate(100%) invert(80%) sepia(40%) saturate(2000%) hue-rotate(180deg) brightness(110%) contrast(110%);
}

/* ===== 名称 ===== */
.tool-name {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  color: rgba(220, 230, 255, 0.85);
  position: relative;
  z-index: 2;
  transition: color 0.3s ease;
}
.tool-card:hover .tool-name {
  color: #fff;
}

/* ===== 空状态 ===== */
.empty {
  width: 100%;
  padding: 60px 0;
  text-align: center;
  color: rgba(190, 210, 255, 0.5);
  font-size: 14px;
  letter-spacing: 2px;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .content-bar { gap: 14px; padding: 20px 14px; }
  .tool-card { width: 110px; height: 130px; padding: 12px; }
  .tool-img { width: 52px; height: 52px; }
  .tool-name { font-size: 13px; }
}

@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; }
  .tool-card:hover .tool-glow { animation: none; }
}
</style>